import { type BaseCustomerDisplayRepository } from "../../_Bases/BaseCustomerDisplayRepository";
import { type LocalDatabaseCustomerDisplay } from "../../_Bases/BaseCustomerDisplayRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBCustomerDisplayRepository extends BaseIndexedDBRepository<
    LocalDatabaseCustomerDisplay
> implements BaseCustomerDisplayRepository {
    public readonly source: InternalIndexedDBDatabase["customerDisplays"];
    protected readonly dataTypeName = "Customer Display";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.customerDisplays;
    }
}
